'use client';
import React from 'react';
import ModalTemplate from '../modals/ModalTemplate';
import { Link } from '@chakra-ui/react';
import { useCart } from '@/context/CartContext';
import { replaceRentalGtm, closeAlreadysubscribedPDPGtm } from '@/lib/Gtmlib';
import { ActiveSubscriptionModalProps } from './types';
import { getUrls } from '@/lib/Urls';

const ActiveSubscriptionModal = ({
  onClose,
  customerAccessToken,
  activeRental,
  handleCart,
  headerText,
  sameProduct,
}: ActiveSubscriptionModalProps) => {
  const { removeItemsFromCart } = useCart();
  const url = getUrls();
  const handleCartItmes = () => {
    replaceRentalGtm();

    removeItemsFromCart();

    handleCart && handleCart();
  };

  const handleClose = () => {
    closeAlreadysubscribedPDPGtm();

    onClose();
  };

  return (
    <ModalTemplate
      showHeaderText={true}
      headerText={headerText}
      showModalBody={true}
      modalContent={
        <div data-testid={'cosmetic-modal-content'}>
          {customerAccessToken && activeRental && (
            <>
              <div className="xl:flex xl:flex-col">
                <div className="text-lg xl:text-xl font-thin mb-3.5 text-justify">
                  {`At this time, Gazelle Flex only allows one rental per customer. If you are trying to rent a device for a friend or family member, please create a separate account for them.`}
                </div>
              </div>
              <div className="mt-5 xl:text-start  text-center">
                <span className=" w-full xl:w-[260px] mb-[20px] cursor-pointer h-[50px] gap-8 text-[16px] font-medium text-[#fff] bg-[#FF6900] rounded-md  ml-auto inline-flex items-center justify-center ">
                  <Link
                    href={`${url.gazelleUrl}/account/`}
                  >
                    Manage my existing rental
                  </Link>
                </span>
                <button
                  type="button"
                  className="text-[#FF6900] text-[16px] font-medium pl-o xl:pl-8 cursor-pointer"
                  data-tracking-id="alreadysubscribed-PDP"
                  onClick={handleClose}
                >
                  Close without adding to cart
                </button>
              </div>
            </>
          )}
          {!sameProduct && !activeRental && (
            <>
              <div className="xl:flex xl:flex-col">
                <div className="text-lg xl:text-xl font-thin mb-3.5 text-justify">
                  {`At this time, Gazelle Flex only allows one rental per customer.`}
                </div>
              </div>
              <div className="mt-5 xl:text-start  text-center">
                <span className=" w-full xl:w-[260px] mb-[20px] cursor-pointer h-[50px] gap-8 text-[16px] font-medium text-[#fff] bg-[#FF6900] rounded-md  ml-auto inline-flex items-center justify-center ">
                  <span
                    data-tracking-id="alreadysubscribed-PDP"
                    onClick={() => handleCartItmes()}
                  >
                    Replace rental in cart with this one{' '}
                  </span>
                </span>
                <button
                  type="button"
                  className="text-[#FF6900] text-[16px] font-medium pl-o xl:pl-8 cursor-pointer"
                  data-tracking-id="alreadysubscribed-PDP"
                  onClick={handleClose}
                >
                  Close without adding to cart
                </button>
              </div>
            </>
          )}
          {sameProduct && (
            <>
              <div className="xl:flex xl:flex-col">
                <div className="text-lg xl:text-xl font-thin mb-3.5 text-justify">
                  You’ve already added this specific device to your cart.
                </div>
              </div>
              <div className="mt-5 xl:text-start  text-center">
                <span className=" w-full xl:w-[150px]  cursor-pointer h-[50px] gap-8 text-[16px] font-medium text-[#fff] bg-[#FF6900] rounded-md  ml-auto inline-flex items-center justify-center ">
                  <Link href={`/cart`}>Continue to Cart</Link>
                </span>
              </div>
            </>
          )}
        </div>
      }
      dataTrackingId="alreadysubscribed-PDP"
      closeModal={handleClose}
      handleClickSolidButton={handleClose}
      showFooter={true}
      setHeight={true}
      height={
        customerAccessToken && activeRental
          ? `md:h-[335px] h-[425px] xl:h-[345px] lg:h-[335px]`
          : `md:h-[250px] h-[290px] xl:h-[280px] lg:h-[250px]`
      }
      setWidth={true}
      width="xl:w-[700px] p-[20px] xl:p-[10px] max-w-lg xl:max-w-screen-lg"
    />
  );
};

export default ActiveSubscriptionModal;
